/**
 * Dynamically updates `alt` text based on screen size for accessibility & SEO.
 * Uses `data-alt` attributes on <source> elements and updates on load
 * and when the layout crosses the mobile/desktop breakpoint.
 * Ensures correct `alt` text is applied when switching between mobile & desktop images.
 */

function media() {
  return {
    init() {
      this.updateAltText();
      const query = window.matchMedia("(max-width: 1023px)");
      const onChange = () => this.updateAltText();
      if (query.addEventListener) {
        query.addEventListener("change", onChange);
      } else {
        query.addListener(onChange);
      }
    },

    updateAltText() {
      // Find all instances of `.responsive-picture`
      document.querySelectorAll(".responsive-picture").forEach((picture) => {
        const imgElement = picture.querySelector("img");
        if (!imgElement) return; // Ensure an <img> element exists

        const sources = picture.querySelectorAll("source");
        let newAlt = imgElement.getAttribute("alt") || ""; // Start with the existing `alt`

        // Check which <source> is currently active based on screen size
        sources.forEach((source) => {
          if (window.matchMedia(source.media).matches) {
            const sourceAlt = source.getAttribute("data-alt");
            if (sourceAlt && sourceAlt.trim() !== "") {
              newAlt = sourceAlt;
            }
          }
        });

        // Only update the `alt` attribute if it has changed (performance optimization)
        if (imgElement.getAttribute("alt") !== newAlt) {
          imgElement.setAttribute("alt", newAlt);
        }
      });
    },
  };
}

export default media;
